
/* Sève — accordion, tier selection and product gallery. */
(function () {
  function money(el) { return el ? el.getAttribute("data-price") : ""; }

  /* ---- FAQ accordion ------------------------------------------------ */
  function faq() {
    var items = document.querySelectorAll(".ln-faq-item");
    for (var i = 0; i < items.length; i++) {
      (function (item) {
        var q = item.querySelector(".ln-faq-q");
        if (!q) return;
        q.addEventListener("click", function () {
          var open = item.getAttribute("data-open") === "true";
          for (var j = 0; j < items.length; j++) {
            items[j].setAttribute("data-open", "false");
            var b = items[j].querySelector(".ln-faq-q");
            if (b) b.setAttribute("aria-expanded", "false");
          }
          if (!open) {
            item.setAttribute("data-open", "true");
            q.setAttribute("aria-expanded", "true");
          }
        });
      })(items[i]);
    }
  }

  /* ---- Tier selection ----------------------------------------------- */
  function tiers() {
    var buttons = document.querySelectorAll(".cta-tier");
    if (!buttons.length) return;
    function select(btn) {
      for (var i = 0; i < buttons.length; i++) buttons[i].setAttribute("aria-pressed", "false");
      btn.setAttribute("aria-pressed", "true");
      var idx = btn.getAttribute("data-tier");
      var inputs = document.querySelectorAll(".seve-variant-input");
      for (var j = 0; j < inputs.length; j++) inputs[j].value = btn.getAttribute("data-variant");
      var prices = document.querySelectorAll(".ln-commit-price");
      for (var k = 0; k < prices.length; k++) prices[k].textContent = money(btn);
      var barT = document.querySelector(".ln-bar-t");
      if (barT) {
        barT.setAttribute("data-i18n", "tiers." + idx + ".qty");
        var q = btn.querySelector(".ln-tier-q");
        if (q) barT.textContent = q.textContent;
      }
    }
    for (var i = 0; i < buttons.length; i++) {
      (function (b) { b.addEventListener("click", function () { select(b); }); })(buttons[i]);
    }
  }

  /* ---- Sticky buy bar on desktop ------------------------------------- */
  function stickyBar() {
    var bar = document.querySelector(".ln-bar");
    var target = document.querySelector(".cta-commit");
    if (!bar || !target || !window.IntersectionObserver || !window.matchMedia) return;
    var wide = window.matchMedia("(min-width: 861px)");
    var footer = document.querySelector(".ln-footer");
    var passed = false, onFooter = false;

    function apply() {
      if (!wide.matches) { bar.classList.remove("is-on"); return; }
      if (passed && !onFooter) bar.classList.add("is-on");
      else bar.classList.remove("is-on");
    }
    new IntersectionObserver(function (e) {
      passed = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
      apply();
    }, { threshold: 0 }).observe(target);
    if (footer) {
      new IntersectionObserver(function (e) {
        onFooter = e[0].isIntersecting;
        apply();
      }, { threshold: 0 }).observe(footer);
    }
    if (wide.addEventListener) wide.addEventListener("change", apply);
    else if (wide.addListener) wide.addListener(apply);
    apply();
  }

  /* ---- Product gallery ---------------------------------------------- */
  function gallery() {
    var root = document.querySelector(".ln-gal");
    if (!root) return;
    var slides = root.querySelectorAll(".ln-gal-slide");
    var thumbs = root.querySelectorAll(".ln-gal-strip button");
    var strip = root.querySelector(".ln-gal-strip");
    if (!slides.length) return;
    var shot = slides.length - 1; /* the in-use frame opens the gallery, like the ads */
    var quiet = true; /* no video download on arrival : the poster is enough */
    var timer = null;
    var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function show(next) {
      shot = (next + slides.length) % slides.length;
      for (var i = 0; i < slides.length; i++) {
        var on = i === shot;
        slides[i].hidden = !on;
        var vid = slides[i].querySelector("video");
        if (vid) {
          if (on && !quiet) { var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {}); }
          else { vid.pause(); }
        }
        if (thumbs[i]) thumbs[i].setAttribute("aria-pressed", on ? "true" : "false");
        var vid = slides[i].querySelector("video");
        if (vid && !on) vid.pause();
        if (vid && on) { try { vid.currentTime = 0; vid.play(); } catch (e) {} }
      }
      if (strip && thumbs[shot]) {
        strip.scrollTo({ left: thumbs[shot].offsetLeft - (strip.clientWidth - thumbs[shot].clientWidth) / 2, behavior: "smooth" });
      }
      schedule();
    }
    function schedule() {
      if (reduced) return;
      if (timer) window.clearTimeout(timer);
      var dwell = slides[shot].querySelector("video") ? 7000 : 4000;
      timer = window.setTimeout(function () { show(shot + 1); }, dwell);
    }
    for (var i = 0; i < thumbs.length; i++) {
      (function (n) { thumbs[n].addEventListener("click", function () { show(n); }); })(i);
    }
    var prev = root.querySelector(".cta-gal.prev");
    var next = root.querySelector(".cta-gal.next");
    if (prev) prev.addEventListener("click", function () { show(shot - 1); });
    if (next) next.addEventListener("click", function () { show(shot + 1); });
    show(shot);
    quiet = false; /* a partir d ici, un clic lance vraiment la video */
  }

  /* ---- Cart : quantity steppers ------------------------------------- */
  function cart() {
    var form = document.querySelector(".ln-cart");
    if (!form) return;
    var apply = form.querySelector(".ln-cart-upd");
    if (!apply) return;
    form.setAttribute("data-js", "1");

    var steps = form.querySelectorAll(".ln-qty-b");
    for (var i = 0; i < steps.length; i++) {
      (function (b) {
        b.addEventListener("click", function () {
          var box = b.parentNode.querySelector(".ln-qty-i");
          if (!box) return;
          var n = parseInt(box.value, 10);
          if (isNaN(n)) n = 1;
          n += parseInt(b.getAttribute("data-step"), 10);
          if (n < 0) n = 0;
          box.value = n;
          apply.click();
        });
      })(steps[i]);
    }
    var boxes = form.querySelectorAll(".ln-qty-i");
    for (var j = 0; j < boxes.length; j++) {
      boxes[j].addEventListener("change", function () { apply.click(); });
    }
  }

  /* ---- Express checkout drawer --------------------------------------- */
  function express() {
    var xp = document.querySelector("[data-xp]");
    if (!xp) return;
    var forms = document.querySelectorAll("form.seve-buy");
    if (!forms.length) return;
    var box = xp.querySelector(".ln-xp-box");
    var source = null;

    function label() {
      var slot = xp.querySelector("[data-xp-label]");
      var on = document.querySelector(".cta-tier[aria-pressed='true'] .ln-tier-q");
      if (slot && on) {
        slot.textContent = on.textContent;
        slot.setAttribute("data-i18n", on.getAttribute("data-i18n") || "");
      }
    }
    function open() {
      label();
      xp.classList.add("is-on");
      xp.setAttribute("aria-hidden", "false");
      document.body.classList.add("ln-locked");
      var first = xp.querySelector(".ln-xp-x");
      if (first) first.focus();
    }
    function close() {
      xp.classList.remove("is-on");
      xp.setAttribute("aria-hidden", "true");
      document.body.classList.remove("ln-locked");
    }

    for (var i = 0; i < forms.length; i++) {
      (function (f) {
        f.addEventListener("submit", function (e) {
          e.preventDefault();
          source = f;
          open();
        });
      })(forms[i]);
    }

    var closers = xp.querySelectorAll("[data-xp-close]");
    for (var j = 0; j < closers.length; j++) closers[j].addEventListener("click", close);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && xp.classList.contains("is-on")) close();
    });
    if (box) box.addEventListener("click", function (e) { e.stopPropagation(); });

    /* voir le panier : on renvoie le formulaire d'origine, qui pointe deja sur /cart */
    var toCart = xp.querySelector("[data-xp-cart]");
    if (toCart) {
      toCart.addEventListener("click", function () {
        var f = source || forms[0];
        var back = f.querySelector("input[name='return_to']");
        if (back) back.value = "/cart";
        HTMLFormElement.prototype.submit.call(f);
      });
    }

    /* repli : aucun portefeuille disponible, on envoie au paiement classique */
    var fb = xp.querySelector("[data-xp-express]");
    var wallet = xp.querySelector("[data-xp-wallet]");
    if (fb && wallet) {
      fb.addEventListener("click", function () {
        var f = source || forms[0];
        var back = f.querySelector("input[name='return_to']");
        if (back) back.value = "/checkout";
        HTMLFormElement.prototype.submit.call(f);
      });
      setTimeout(function () {
        if (wallet.offsetHeight < 24) { fb.hidden = false; wallet.style.display = "none"; }
      }, 2200);
    }
  }

  /* ---- Launch offer countdown ---------------------------------------- */
  function promo() {
    var bar = document.querySelector("[data-promo]");
    var slot = bar ? bar.querySelector("[data-countdown]") : null;
    if (!bar || !slot) return;
    var end = Date.parse(bar.getAttribute("data-end"));
    if (isNaN(end)) { bar.hidden = true; return; }
    var notes = document.querySelectorAll("[data-promo-note]");

    function stop() {
      bar.hidden = true;
      for (var i = 0; i < notes.length; i++) notes[i].hidden = true;
    }
    function pad(n) { return n < 10 ? "0" + n : "" + n; }

    function tick() {
      var left = end - Date.now();
      if (left <= 0) { stop(); return false; }
      var u = (slot.getAttribute("data-units") || "j|h|min|s").split("|");
      var d = Math.floor(left / 86400000);
      var h = Math.floor(left / 3600000) % 24;
      var m = Math.floor(left / 60000) % 60;
      var sec = Math.floor(left / 1000) % 60;
      var out = d > 0
        ? d + u[0] + " " + pad(h) + u[1] + " " + pad(m) + u[2]
        : pad(h) + u[1] + " " + pad(m) + u[2] + " " + pad(sec) + u[3];
      if (slot.textContent !== out) slot.textContent = out;
      return true;
    }

    if (tick()) setInterval(tick, 1000);
  }

  /* ---- Daily processing cut-off -------------------------------------- */
  function cutoff() {
    var box = document.querySelector("[data-cutoff]");
    var slot = box ? box.querySelector("[data-cut-c]") : null;
    if (!box || !slot || !window.Intl || !Intl.DateTimeFormat) { if (box) box.hidden = true; return; }

    var hour = parseInt(box.getAttribute("data-hour"), 10);
    if (isNaN(hour) || hour < 0 || hour > 23) { box.hidden = true; return; }

    var fmt;
    try {
      fmt = new Intl.DateTimeFormat("fr-FR", {
        timeZone: "Europe/Paris", hour12: false,
        hour: "2-digit", minute: "2-digit", second: "2-digit"
      });
    } catch (e) { box.hidden = true; return; }

    function parisSeconds() {
      var parts = fmt.formatToParts(new Date()), o = {};
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].type !== "literal") o[parts[i].type] = parseInt(parts[i].value, 10);
      }
      var h = o.hour === 24 ? 0 : o.hour;
      return h * 3600 + o.minute * 60 + o.second;
    }
    function pad(n) { return n < 10 ? "0" + n : "" + n; }

    function tick() {
      var left = hour * 3600 - parisSeconds();
      if (left <= 0) left += 86400;
      var h = Math.floor(left / 3600);
      var m = Math.floor(left / 60) % 60;
      var sec = left % 60;
      var u = (slot.getAttribute("data-units") || "h|min|s").split("|");
      var out = h > 0 ? h + u[0] + " " + pad(m) + u[1] : m + u[1] + " " + pad(sec) + u[2];
      if (slot.textContent !== out) slot.textContent = out;
    }
    slot.setAttribute("data-units", "h|min|s");
    slot.setAttribute("data-i18n-attr", "data-units:cutoff.units");
    tick();
    setInterval(tick, 1000);
  }

  /* ---- Videos loaded only when they reach the screen ------------------ */
  function lazyVideos() {
    var vids = document.querySelectorAll("video[data-lazyvideo]");
    if (!vids.length) return;
    if (!window.IntersectionObserver) {
      for (var k = 0; k < vids.length; k++) { var p0 = vids[k].play(); if (p0 && p0.catch) p0.catch(function () {}); }
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var v = entries[i].target;
        if (entries[i].isIntersecting) {
          v.preload = "auto";
          var pr = v.play();
          if (pr && pr.catch) pr.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      }
    }, { rootMargin: "200px 0px", threshold: 0.15 });
    for (var j = 0; j < vids.length; j++) io.observe(vids[j]);
  }

  function boot() { faq(); tiers(); gallery(); stickyBar(); cart(); express(); promo(); cutoff(); lazyVideos(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();

/* --- v8 : relance de la vidéo d'accroche mobile si l'autoplay est refusé
   (mode économie d'énergie iOS, onglet en arrière-plan, réseau lent) --- */
(function () {
  function init() {
    var v = document.querySelector('.ln-mhero-frame video');
    if (!v) return;
    v.muted = true;
    v.setAttribute('muted', '');
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    var armed = false;
    function onGesture() { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    function arm() {
      if (armed) return;
      armed = true;
      ['touchstart', 'pointerdown', 'click', 'scroll', 'keydown'].forEach(function (e) {
        document.addEventListener(e, onGesture, { once: true, passive: true });
      });
    }
    function go() {
      var p = v.play();
      if (p && p.catch) p.catch(arm);
    }
    if (v.readyState >= 2) go();
    v.addEventListener('loadeddata', go, { once: true });
    v.addEventListener('canplay', go, { once: true });
    setTimeout(go, 1500);
    setTimeout(function () { if (v.paused) arm(); }, 3000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
